import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import ImperialTobacco from '../../assets/img/ImperialTobacco.svg';

import './footer.css';

const Footer = (props) => {
  const { links, optedInToPpc, ppcManagementUrl } = props;
  return (
    <footer className="user-footer">
      <div className="user-footer-container">
        <img src={ImperialTobacco} alt='Imperial Tobacco' />
        <div className="links">
          {links.map(link => (
            ((link.title === 'Ignite Mastercard Management' && optedInToPpc) || link.title !== 'Ignite Mastercard Management') && (
              <Link
                key={link.title}
                to={link.title === 'Ignite Mastercard Management' ? ppcManagementUrl : link.href}
                target={link.target}
              >
                {link.title}
              </Link>
            )
          ))}
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = state => ({
  optedInToPpc: state.viewConfig.profile.attributes['opted-in-to-ppc'],
  ppcManagementUrl: state.ppc.ppcManagementUrl
});

export default connect(mapStateToProps)(Footer);




// WEBPACK FOOTER //
// ./src/components/footer/user-footer.jsx